import React, { useState, useRef } from 'react';
import { Alert } from 'react-bootstrap';
import moment from 'moment';
import ValidacionFilter from '../../components/filters/ValidacionFilter';
import BsButton from '../../collection/bootstrap/BsButton';
import { useLoad } from '../../collection/Hooks';
import { apiBlobForm, apiUrl } from '../../utils/api';
import { generateFormData } from '../../utils/functions';

export default function ExcelGastos(props) {
    // alert message
    const [excelMessage] = useLoad(async () => {
        const response = await fetch(apiUrl("gastos/excel-message"));
        return await response.text();
    }, []);

    // download excel
    const descargarExcel = async () => {
        const url = apiUrl("gastos/excel");
        window.location.replace(url);
    };

    // default filter
    const defaultFilter = {
        desde: moment().startOf('month').format("YYYY-MM-DD"),
        hasta: null,
        trabajador: null,
        pendiente: true,
        validado: null
    };
    const filter = useRef(generateFormData(defaultFilter));

    // show excel button
    const [showExcelButton, setShowExcelButton] = useState(false);

    // filter calls
    const setFilter = async newFilter => {
        const actualFilter = newFilter ?? filter.current;
        filter.current = actualFilter;
        newFilter ? setShowExcelButton(true) : setShowExcelButton(false);
    }

    // audit excel download
    const downloadAuditExcel = async () => {
        const blob = await apiBlobForm("gastos/auditExcel", filter.current);
        const url = window.URL.createObjectURL(blob);

        // download file
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'GastosAudit_' + filter.current.get("desde") + '_' + filter.current.get("hasta") + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    return <>
        <h2>Excel de gastos</h2>
        <p>
            Cada vez que se genera este archivo, se incluyen en él todos los gastos validados que todavía no
            han sido exportados antes.
        </p>
        <p>
            Todos los gastos incluidos en el archivo son marcados como exportados y no volverán a ser
            incluidos en ningún otro documento de Excel generado con esta herramienta.
        </p>

        {excelMessage &&
            <Alert variant="warning" className="mt-3 fw-bold">
                {excelMessage}
            </Alert>
        }

        <BsButton className="mt-3" onClick={descargarExcel}>
            Generar Excel
        </BsButton>

        <h4 className="mt-5">Excel Filtrado</h4>
        <p>La generación de este excel muestra todo tipo de gastos y no marca como exportados, solo tiene fines informativos.</p>
        <ValidacionFilter
            className="my-3" fem
            defaultValue={defaultFilter}
            selectFechas
            selectDepartamento
            selectTrabajador
            onFilter={setFilter}    />

        {showExcelButton && <BsButton className="mb-2 me-2" onClick={downloadAuditExcel}>Descargar Excel Auditoría</BsButton>}
    </>;
}
